import type { SailState } from './shipTemplates';
import type { FormedTemplate } from './shipForm';
import type { FormedMast } from './shipMastPlan';

/* Masts stand along the hull from the bow at position 0. */
function isForeCourse(template: FormedTemplate, mast: FormedMast): boolean {
  const square = template.masts.filter((m) => (m.rig ?? 'square') === 'square');
  const fore = square.reduce((a, b) => (b.position < a.position ? b : a));
  return mast.config === fore;
}

/** Whether a formed ship in `state` spreads the sail of `mast`, or keeps it furled. */
export function spreadOn(template: FormedTemplate, mast: FormedMast, state: SailState): boolean {
  switch (state) {
    case 'set':
      return true;
    case 'furled':
      return false;
    case 'fore':
      return isForeCourse(template, mast);
    case 'foreAndMizzen':
      return mast.config.rig === 'lateen' || isForeCourse(template, mast);
  }
}
